export default function resetOrigin() {
  const url = new URL(window.location.href);
  const prevUrl = url.href;
  const nextUrl = url.origin + url.pathname;
  if (prevUrl !== nextUrl) {
    window.history.pushState({ path: nextUrl }, "", nextUrl);
  }
  return true;
}
